export default function BenefitsCard({ key, extraClass, src, title, detail, width }) {
    return (
        <div key={key} className={`cursor-pointer service-box p-4 ${extraClass}`}>
            {src ? <img src={src} alt={title} className="mb-3" width={width} /> : null}
            {title ? <h3 className="mt-2 text-2xl font-semibold">{title}</h3> : null}
            {detail ? <p className="text-base text-gray-color mt-2">{detail}</p> : null}
        </div>
    );
}
